import React from 'react';
import { Button } from '@mui/material';

function BotaoNavHeader({ navigate, rota, texto }) {
      return (
            <Button onClick={()=>navigate(rota)} color="inherit">{texto}</Button>

      );
}

export default BotaoNavHeader